import moment from "moment";
import { FAILURE, POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaSolicitudProducto(obj, combo = false, tag) {
  try {
    let data = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/obtener-lista-solicitud-producto",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      // data.error = false;
      data = body;
      if (combo === false) {
        for (let i = 0; i < data.length; i++) {
          data[i].fechaProceso = moment(data[i].fechaProceso).format(
            "YYYY/MM/DD HH:mm",
          );
          data[i].habilitadoLabel =
            data[i].habilitado === 1
              ? tag("column_habilitado")
              : tag("column_deshabilitado");
          data[i].rowsData = data[i].detalle;
          data[i].rowsData = data[i].rowsData.map((item) => {
            item.fechaProceso = moment(item.fechaProceso).format(
              "YYYY/MM/DD HH:mm",
            );
            return item;
          });
        }
      }
      if (combo === true) {
        data = data.map((item) => {
          const id = item.id;
          const codigo = item.codigo ?? "";
          const descripcion = item.descripcion;
          return {
            value: id,
            label: codigo + " - " + descripcion,
          };
        });
      }
    }
    return data;
  } catch (err) {
    console.log("obtenerListaSolicitudProducto err");
    console.log(err);
    return [];
  }
}

export async function obtenerListaSolicitudProductoAprobado(
  obj,
  combo = false,
  tag,
) {
  try {
    let data = [];
    const { code, body } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/obtener-lista-solicitud-producto-aprobado",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    if (code === SUCCESS) {
      data = body;
      if (combo === false) {
        for (let i = 0; i < data.length; i++) {
          data[i].fechaProceso = moment(data[i].fechaProceso).format(
            "YYYY/MM/DD HH:mm",
          );
          data[i].habilitadoLabel =
            data[i].habilitado === 1
              ? tag("column_habilitado")
              : tag("column_deshabilitado");
          data[i].rowsData = data[i].detalle;
          if (Array.isArray(data[i].rowsData)) {
            data[i].rowsData = data[i].rowsData.map((item) => {
              item.fechaProceso = moment(item.fechaProceso).format(
                "YYYY/MM/DD HH:mm",
              );
              return item;
            });
          }
        }
      }
      if (combo === true) {
        data = data.map((item) => {
          const id = item.id;
          const codigo = item.codigo ?? "";
          const descripcion = item.descripcion;
          return {
            value: id,
            label: codigo + " - " + descripcion,
          };
        });
      }
    }
    console.log(data);
    return data;
  } catch (err) {
    console.log("obtenerListaSolicitudProductoAprobado err");
    console.log(err);
    return [];
  }
}

export async function crearSolicitudProducto(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/crear-solicitud-producto",
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("crearSolicitudProducto err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function actualizarSolicitudProducto(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/actualizar-solicitud-producto",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("actualizarSolicitudProducto err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function aprobarSolicitudProducto(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/aprobar-solicitud-producto",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    if (code === SUCCESS) {
      data.error = false;
      data.message = message;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("aprobarSolicitudProducto err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function rechazarSolicitudProducto(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/rechazar-solicitud-producto",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    if (code === SUCCESS) {
      data.error = false;
      data.message = message;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("rechazarSolicitudProducto err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function deshabilitarSolicitudProducto(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/deshabilitar-solicitud-producto",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("deshabilitarSolicitudProducto err");
    console.log(err);
    return { error: true, message: err };
  }
}

export async function habilitarSolicitudProducto(obj) {
  try {
    let data = { error: true };
    const { code, message } = await fetch(
      "https://gestiondeflota.boltrack.net/apiultimamillav3/api/solicitud-producto/habilitar-solicitud-producto",
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      },
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
    }
    if (code === FAILURE) {
      data.error = true;
      data.message = message;
    }
    return data;
  } catch (err) {
    console.log("habilitarSolicitudProducto err");
    console.log(err);
    return { error: true, message: err };
  }
}
